<template>
  <input/>
</template>

<script>
  let vm = {
    name: 'input-texto',
    props: {
      value: [String, Number],
      speed: {
        default: 20
      }
    },
    mounted () {
      var vmm = this
      $(this.$el).val(this.value)
      $(this.$el).on('change', function () {
        vmm.$emit('input', this.value)
      })
    },
    watch: {
      value: function (value) {
        // update value
        $(this.$el).val(value)
        $(this.$el).trigger('paste')
        $(this.$el).trigger('input')
      }
    }
  }
  module.exports = vm
</script>



// WEBPACK FOOTER //
// src/components/spark-components/spark-scrollbar/SparkInputTexto.vue